module.exports = __webpack_public_path__ + "img/4.741dce3.png";